import { Machine, assign } from "xstate";
import { WorkViewModule } from "@/store/modules/workView.module";
function getFormattedDateString(value) {
    return `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}T00:00:00`;
}
const workViewMachine = Machine({
    id: "workView",
    context: {
        displayDate: undefined,
        operationDate: undefined,
        teamId: "",
    },
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "gettingTeamsList",
            },
        },
        gettingTeamsList: {
            invoke: {
                id: "gettingTeamsList",
                src: (context, event) => {
                    return WorkViewModule.GetTeamList();
                },
                onDone: [
                    { target: "loadedTeamsList", cond: "hasTeams" },
                    { target: "noTeamsAvailable", cond: "hasNoTeams" },
                ],
                onError: { target: "error" },
            },
        },
        noTeamsAvailable: {},
        loadedTeamsList: {
            on: {
                LIVE_USERS_ENTRIES: { target: "gettingLiveViewUserModeEntries" },
                DAY_USERS_ENTRIES: { target: "gettingDayViewUserModeEntries", actions: "getToday" },
                PROJECT_LIVE_USERS_ENTRIES: { target: "gettingLiveViewProjectModeEntries" },
                WEEK_USERS_ENTRIES: { target: "gettingWeekViewUserModeEntries", actions: "getToday" },
                CHANGE_TEAM: { target: "gettingLiveViewUserModeEntries" },
            },
        },
        gettingLiveViewUserModeEntries: {
            tags: "live",
            invoke: {
                id: "gettingLiveViewUserModeEntries",
                src: (context, event) => {
                    return WorkViewModule.GetLiveViewUserModeEntries(event.teamId);
                },
                onDone: { target: "loadedLiveViewUserModeEntries" },
                onError: { target: "error" },
            },
        },
        loadedLiveViewUserModeEntries: {
            tags: "live",
            on: {
                LIVE_USERS_ENTRIES: { target: "gettingLiveViewUserModeEntries" },
                DAY_USERS_ENTRIES: { target: "gettingDayViewUserModeEntries", actions: "getToday" },
                PROJECT_LIVE_USERS_ENTRIES: { target: "gettingLiveViewProjectModeEntries" },
                WEEK_USERS_ENTRIES: { target: "gettingWeekViewUserModeEntries", actions: "getToday" },
                CHANGE_TEAM: { target: "gettingLiveViewUserModeEntries" },
            },
        },
        gettingDayViewUserModeEntries: {
            tags: "day",
            invoke: {
                id: "gettingDayViewUserModeEntries",
                src: "fetchDayEntries",
                onDone: { target: "loadedDayViewUserModeEntries" },
                onError: { target: "error" },
            },
        },
        loadedDayViewUserModeEntries: {
            tags: ["showDatePicker", "day"],
            on: {
                LIVE_USERS_ENTRIES: { target: "gettingLiveViewUserModeEntries" },
                PREV_DAY: {
                    target: "gettingDayViewUserModeEntries",
                    actions: "decrementDay",
                },
                NEXT_DAY: {
                    target: "gettingDayViewUserModeEntries",
                    actions: "incrementDay",
                },
                CHANGE_DISPLAY_DATE: {
                    target: "gettingDayViewUserModeEntries",
                    actions: "changeDate",
                },
                PROJECT_DAY_USERS_ENTRIES: {
                    target: "gettingDayViewProjectModeEntries",
                },
                DAY_USERS_ENTRIES: { target: "gettingDayViewUserModeEntries", actions: "getToday" },
                WEEK_USERS_ENTRIES: { target: "gettingWeekViewUserModeEntries", actions: "getToday" },
                CHANGE_TEAM: { target: "gettingDayViewUserModeEntries" },
            },
        },
        gettingLiveViewProjectModeEntries: {
            tags: "live",
            invoke: {
                id: "gettingLiveViewProjectModeEntries",
                src: (context, event) => {
                    return WorkViewModule.GetLiveViewProjectModeUsers(event.teamId);
                },
                onDone: { target: "loadedLiveViewProjectModeEntries" },
                onError: { target: "error" },
            },
        },
        loadedLiveViewProjectModeEntries: {
            tags: "live",
            on: {
                LIVE_USERS_ENTRIES: { target: "gettingLiveViewUserModeEntries" },
                DAY_USERS_ENTRIES: { target: "gettingDayViewUserModeEntries", actions: "getToday" },
                CHANGE_TEAM: { target: "gettingLiveViewProjectModeEntries" },
                WEEK_USERS_ENTRIES: { target: "gettingWeekViewUserModeEntries", actions: "getToday" },
            },
        },
        gettingDayViewProjectModeEntries: {
            tags: "day",
            invoke: {
                id: "gettingDayViewProjectModeEntries",
                src: "fetchProjectDayEntries",
                onDone: { target: "loadedDayViewProjectModeEntries" },
                onError: { target: "error" },
            },
        },
        loadedDayViewProjectModeEntries: {
            tags: ["showDatePicker", "day"],
            on: {
                LIVE_USERS_ENTRIES: { target: "gettingLiveViewUserModeEntries" },
                DAY_USERS_ENTRIES: { target: "gettingDayViewUserModeEntries", actions: "getToday" },
                WEEK_USERS_ENTRIES: { target: "gettingWeekViewUserModeEntries", actions: "getToday" },
                PREV_DAY: {
                    target: "gettingDayViewProjectModeEntries",
                    actions: "decrementDay",
                },
                NEXT_DAY: {
                    target: "gettingDayViewProjectModeEntries",
                    actions: "incrementDay",
                },
                CHANGE_DISPLAY_DATE: {
                    target: "gettingDayViewProjectModeEntries",
                    actions: "changeDate",
                },
                PROJECT_DAY_USERS_ENTRIES: {
                    target: "gettingDayViewProjectModeEntries",
                    actions: "getToday",
                },
                CHANGE_TEAM: { target: "gettingDayViewProjectModeEntries" },
            },
        },
        gettingWeekViewUserModeEntries: {
            tags: "week",
            invoke: {
                id: "gettingWeekViewUserModeEntries",
                src: "fetchWeekViewUserEntries",
                onDone: { target: "loadedWeekViewUserModeEntries" },
                onError: { target: "error" },
            },
        },
        loadedWeekViewUserModeEntries: {
            tags: ["showDatePicker", "week"],
            on: {
                LIVE_USERS_ENTRIES: { target: "gettingLiveViewUserModeEntries" },
                DAY_USERS_ENTRIES: { target: "gettingDayViewUserModeEntries", actions: "getToday" },
                WEEK_USERS_ENTRIES: { target: "gettingWeekViewUserModeEntries", actions: "getToday" },
                PROJECT_WEEK_USERS_ENTRIES: { target: "gettingWeekViewProjectModeEntries" },
                CHANGE_TEAM: { target: "gettingWeekViewUserModeEntries" },
                CHANGE_DISPLAY_DATE: {
                    target: "gettingWeekViewUserModeEntries",
                    actions: "changeDate",
                },
                PREV_DAY: {
                    target: "gettingWeekViewUserModeEntries",
                    actions: "decrementDay",
                },
                NEXT_DAY: {
                    target: "gettingWeekViewUserModeEntries",
                    actions: "incrementDay",
                },
            },
        },
        gettingWeekViewProjectModeEntries: {
            tags: "week",
            invoke: {
                id: "gettingWeekViewProjectModeEntries",
                src: "fetchWeekViewProjectEntries",
                onDone: { target: "loadedWeekViewProjectModeEntries" },
                onError: { target: "error" },
            },
        },
        loadedWeekViewProjectModeEntries: {
            tags: ["showDatePicker", "week"],
            on: {
                LIVE_USERS_ENTRIES: { target: "gettingLiveViewUserModeEntries" },
                DAY_USERS_ENTRIES: { target: "gettingDayViewUserModeEntries", actions: "getToday" },
                WEEK_USERS_ENTRIES: { target: "gettingWeekViewUserModeEntries", actions: "getToday" },
                PROJECT_WEEK_USERS_ENTRIES: { target: "gettingWeekViewProjectModeEntries" },
                CHANGE_TEAM: { target: "gettingWeekViewProjectModeEntries" },
                CHANGE_DISPLAY_DATE: {
                    target: "gettingWeekViewProjectModeEntries",
                    actions: "changeDate",
                },
                PREV_DAY: {
                    target: "gettingWeekViewProjectModeEntries",
                    actions: "decrementDay",
                },
                NEXT_DAY: {
                    target: "gettingWeekViewProjectModeEntries",
                    actions: "incrementDay",
                },
            },
        },
        error: { type: "final" },
    },
}, {
    actions: {
        changeDate: assign({
            displayDate: (context, event) => {
                return event.value;
            },
        }),
        decrementDay: assign({
            displayDate: (context, event) => {
                let dMinus = new Date(context.displayDate);
                dMinus.setDate(context.displayDate.getDate() - 1);
                return dMinus;
            },
        }),
        incrementDay: assign({
            displayDate: (context, event) => {
                if (context.displayDate.toDateString() == context.operationDate.toDateString()) {
                    return context.displayDate;
                }
                let dPlus = new Date(context.displayDate);
                dPlus.setDate(context.displayDate.getDate() + 1);
                return dPlus;
            },
        }),
        getToday: assign({
            displayDate: (context, event) => {
                let todayDay = new Date();
                return todayDay;
            },
        }),
    },
    guards: {
        hasTeams: () => WorkViewModule.teams.length > 0,
        hasNoTeams: () => WorkViewModule.teams.length == 0,
    },
    activities: {},
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 2000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
        fetchDayEntries: (_, __) => {
            return WorkViewModule.GetDayWorkViewEntries({ entryDate: getFormattedDateString(_.displayDate), teamId: __.teamId });
        },
        fetchProjectDayEntries: (_, __) => {
            return WorkViewModule.GetDayViewProjectModeUsers({ entryDate: getFormattedDateString(_.displayDate), teamId: __.teamId });
        },
        fetchWeekViewUserEntries: (_, __) => {
            return WorkViewModule.GetWeekViewUserModeEntries({ entryDate: getFormattedDateString(_.displayDate), teamId: __.teamId });
        },
        fetchWeekViewProjectEntries: (_, __) => {
            return WorkViewModule.GetWeekViewProjectModeEntries({ entryDate: getFormattedDateString(_.displayDate), teamId: __.teamId });
        },
    },
});
export default workViewMachine;
